import {
  ScheduledLessonExamRecordSource,
  StudentExamRecordSource,
  StudentExamSources,
} from '@/utils/student-exam/studentExamRecordTypes';
import { groupItems } from '@/utils/shared/groupItems';
import { hashMap } from '@/utils/shared/hashMap';

export type GroupStudentExamSourcesParams = {
  studentExams: StudentExamRecordSource[];
  scheduledLessonExams: ScheduledLessonExamRecordSource[];
};

const pickScheduledLessonExam = (
  candidates: ScheduledLessonExamRecordSource[] = [],
) => candidates.find(({ examSchedule }) => !!examSchedule) ?? candidates.at(0);

export const groupStudentExamSources = ({
  studentExams,
  scheduledLessonExams,
}: GroupStudentExamSourcesParams): StudentExamSources[] => {
  const examsById = hashMap(
    [...scheduledLessonExams, ...studentExams].map(({ exam }) => exam),
    ({ id }) => id,
  );

  const lessonsByExamId = groupItems(
    scheduledLessonExams,
    ({ exam }) => exam.id,
  );
  const studentExamsByExamId = hashMap(studentExams, ({ exam }) => exam.id);

  return Array.from(examsById.values(), exam => ({
    exam,
    scheduledLessonExam: pickScheduledLessonExam(lessonsByExamId.get(exam.id)),
    studentExam: studentExamsByExamId.get(exam.id),
  }));
};
